import { AlertCircle } from 'lucide-react';
import type { FriendlyError } from '@/lib/errors';

interface ErrorAlertProps {
  error: FriendlyError;
  className?: string;
}

export default function ErrorAlert({ error, className = '' }: ErrorAlertProps) {
  return (
    <div
      className={`rounded-xl bg-error-light border border-error/15 px-3.5 py-3 flex gap-2.5 ${className}`}
    >
      <AlertCircle
        size={16}
        className="text-error flex-shrink-0 mt-0.5"
        aria-hidden
      />
      <div className="flex-1 min-w-0 text-left">
        <p className="font-display font-semibold text-sm text-error leading-tight">
          {error.title}
        </p>
        <p className="font-sans text-[13px] text-error/80 mt-1 leading-snug">
          {error.message} {error.action}
        </p>
      </div>
    </div>
  );
}
